// Web NFC and the camera cannot share a document. Measured on a field Android:
// once getUserMedia opens a camera, NDEFReader.scan() never delivers another
// reading in that document, and none of closing the camera, aborting and calling
// scan() again, or moving the camera into a same-origin iframe brings it back.
// Only a real page load does — which is why the chip writer splits its two steps
// across a navigation.
//
// Everywhere else both readers stay on the screen and the operator picks one per
// card. What is left to do is say so when the choice has already been made: a
// reader that looks armed but is dead is how an operator ends up tapping a card
// against a phone that stopped listening.
//
// The flag is module state rather than controller state on purpose. Turbo swaps
// the DOM without reloading the page, so an nfc-reader that connects on the next
// screen is still inside the same poisoned document; only a real load resets this
// module along with the camera.
let opened = false

export const cameraHasOpened = () => opened

// Called once the camera stream is actually running — a getUserMedia that was
// refused never opened anything and costs no NFC.
export function reportCameraOpened() {
  if (opened) return

  opened = true
  window.dispatchEvent(new CustomEvent("camera:opened"))
}
